'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderUserDetails = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderUserDetails = exports.HeaderUserDetails = function (_Component) {
  (0, _inherits3.default)(HeaderUserDetails, _Component);

  function HeaderUserDetails() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, HeaderUserDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = HeaderUserDetails.__proto__ || (0, _getPrototypeOf2.default)(HeaderUserDetails)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleClick = function (event) {
      var _this$props = _this.props,
          mediaQueryLg = _this$props.mediaQueryLg,
          onDropdownStateToggled = _this$props.onDropdownStateToggled;


      if (!mediaQueryLg) {
        event.preventDefault();
        onDropdownStateToggled();
      }
    }, _this2.handleMouseLeave = function () {
      var _this$props2 = _this.props,
          mediaQueryLg = _this$props2.mediaQueryLg,
          onDropdownStateToggled = _this$props2.onDropdownStateToggled;


      if (mediaQueryLg) {
        _this.timer = setTimeout(onDropdownStateToggled, 750);
      }
    }, _this2.handleMouseEnter = function () {
      var _this$props3 = _this.props,
          mediaQueryLg = _this$props3.mediaQueryLg,
          dropdownOpen = _this$props3.dropdownOpen,
          onDropdownStateToggled = _this$props3.onDropdownStateToggled;


      clearTimeout(_this.timer);

      if (mediaQueryLg && !dropdownOpen) {
        onDropdownStateToggled();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(HeaderUserDetails, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dropdownOpen = _props.dropdownOpen,
          mediaQueryLg = _props.mediaQueryLg,
          avatarUrl = _props.avatarUrl,
          firstName = _props.firstName,
          children = _props.children;


      return _react2.default.createElement(
        'div',
        {
          className: 'header__dropdown',
          onClick: this.handleClick,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('header__dropdown__target', {
              'header__dropdown__target--open': dropdownOpen
            })
          },
          _react2.default.createElement(
            'div',
            { className: 'header__dropdown__avatar' },
            avatarUrl ? _react2.default.createElement('img', { src: avatarUrl, alt: 'user avatar' }) : _react2.default.createElement(
              'span',
              null,
              (firstName || '').slice(0, 1)
            )
          ),
          _react2.default.createElement(_reactInlinesvg2.default, { className: 'header__dropdown__arrow svg', uniquifyIDs: false, src: require('../../../static/img/arrow.svg') })
        ),
        dropdownOpen && mediaQueryLg && children && _react2.default.createElement(
          'div',
          { className: 'header__dropdown__panel' },
          children
        )
      );
    }
  }]);
  return HeaderUserDetails;
}(_react.Component);

HeaderUserDetails.propTypes = {
  avatarUrl: _propTypes2.default.string,
  children: _propTypes2.default.node,
  dropdownOpen: _propTypes2.default.bool,
  firstName: _propTypes2.default.string,
  mediaQueryLg: _propTypes2.default.bool,
  onDropdownStateToggled: _propTypes2.default.func.isRequired
};